import { Lifecycle } from 'tsyringe';
import { ILoggerToken, LogLevel } from './ILogger.js';
import { services } from '@quandis/qbo4.ui';
export class ConsoleLogger {
    logTrace(message, ...args) {
        console.debug(message, ...args);
    }
    logDebug(message, ...args) {
        console.debug(message, ...args);
    }
    logInformation(message, ...args) {
        console.info(message, ...args);
    }
    logWarning(message, ...args) {
        console.warn(message, ...args);
    }
    logError(message, error, ...args) {
        console.error(message, ...(error ? [error, ...args] : args));
    }
    logCritical(message, error, ...args) {
        console.error(`CRITICAL: ${message}`, ...(error ? [error, ...args] : args));
    }
    log(level, message, error, ...args) {
        switch (level) {
            case LogLevel.Trace:
                this.logTrace(message, ...args);
                break;
            case LogLevel.Debug:
                this.logDebug(message, ...args);
                break;
            case LogLevel.Information:
                this.logInformation(message, ...args);
                break;
            case LogLevel.Warning:
                this.logWarning(message, ...args);
                break;
            case LogLevel.Error:
                this.logError(message, error, ...args);
                break;
            case LogLevel.Critical:
                this.logCritical(message, error, ...args);
                break;
            default:
                console.log(message, ...args);
                break;
        }
    }
}
services.container.register(ILoggerToken, { useClass: ConsoleLogger }, { lifecycle: Lifecycle.Singleton });
//# sourceMappingURL=ConsoleLogger.js.map